<section class="flex flex-col w-full page-wrapper">
  <div class="w-full py-4 block sm:hidden">
    <go-back></go-back>
  </div>
  <div class="text-center header">
    <h2 class="heading-medium outfit bold m-0">{{ 'okeeyCash.applyToOkeeyCashTitle' | translate }}</h2>
    <p class="paragraph-medium outfit font-normal">{{ 'okeeyCash.welcomeToUniga&Okeeycash' | translate }}</p>
  </div>
  <div class="flex justify-center py-8 md:py-10 items-center img-container">
    <img src="../../../../../assets/img/my-okeey-cash/apply-2-okeey-cash-desktop.svg" alt="" />
  </div>
  <div class="w-full flex flex-col gap-8 pb-10 text-element">
    <div class="text-center md:inline-block">
      <span class="paragraph-medium light outfit">{{ 'okeeyCash.settingFinancialAccount' | translate }}</span>
      <span class="paragraph-medium outfit medium">{{ 'okeeyCash.stepByStep' | translate }}</span>
    </div>
    <div class="text-center md:inline-block">
      <span class="paragraph-medium light outfit">{{ 'okeeyCash.privacyAndSecurity' | translate }}</span>
      <span class="paragraph-medium outfit medium">{{ 'okeeyCash.yourInformationIsSafe' | translate }}</span>
      <span class="paragraph-medium light outfit">{{ 'okeeyCash.withUs' | translate }}</span>
      <span class="paragraph-medium outfit medium">{{ 'okeeyCash.thirdParties' | translate }}</span>
      <span class="paragraph-medium light outfit">{{ 'okeeyCash.includingAdvertisers' | translate }}</span>
    </div>
  </div>
  <div class="flex flex-col gap-10 md:gap-12">
    <div class="block text-center text-element">
      <p class="paragraph-medium outfit medium">{{ 'okeeyCash.readyToBegin' | translate }}</p>
      <p class="paragraph-medium light outfit">{{ 'okeeyCash.startFullTutorial' | translate }}</p>
    </div>
    <korviu-button type="button" color="tertiary" (click)="goToTutorial()" class="w-full">{{
      'okeeyCash.startTutorial' | translate
    }}</korviu-button>
  </div>
  <div class="py-12 grid gap-4 sm:gap-6 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4">
    @for (item of okeeyCash; track item; let i = $index) {
      <ng-container class="flex p-4">
        <div class="flex flex-col overflow-hidden cursor-pointer card" (click)="navigateToTutorial(i)">
          <div class="card-image"><img [src]="item.imgSrc" [alt]="" class="w-full" /></div>
          <div class="flex gap-2 flex-col px-4 pt-2 pb-4 card-content">
            <h2 class="paragraph-medium medium outfit ellipsis">
              {{ item.title | translate }}
            </h2>
            <p class="paragraph-small-card light outfit">{{ item.description | translate }}</p>
          </div>
        </div>
      </ng-container>
    }
  </div>
  <korviu-button type="button" color="tertiary" (click)="goToOkeeyCash()" class="w-full">{{
    'okeeyCash.applyToOkeeyCash' | translate
  }}</korviu-button>
</section>
